/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import LookupActions from '../lookup-actions';

const CONSTANTS = {
    GET: {
        ERROR: 'theme_actions.get.error',
        START: 'theme_actions.get.start',
        SUCCESS: 'theme_actions.get.success'
    },
    MESSAGES: {
        CREATE_ERROR: 'lookups.theme.create.error',
        CREATE_OK: 'lookups.theme.create.ok',
        REMOVE_ERROR: 'lookups.theme.remove.error',
        REMOVE_OK: 'lookups.theme.remove.ok',
        SAVE_ERROR: 'lookups.theme.save.error',
        SAVE_OK: 'lookups.theme.save.ok',
    },
    REMOVE_OK: 'theme_actions.remove',
    SAVE_OK: 'theme_actions.save',
};

class ThemeActions extends LookupActions {

    constructor(path, CONSTS) {
        super(path, CONSTS);
    }

}

let actions = new ThemeActions('lookup/theme', CONSTANTS);

export {
    actions as ThemeActions,
    CONSTANTS as ThemeConstants
};
